import { useTranslation } from "react-i18next";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination,
  Paper,
  TableContainer,
} from "@material-ui/core";
import ReportItem from "./ReportItem";

import { EmailLogReportsResponse } from "@dashboard-v3/api";
import { useStyles } from "../styled";

interface ReportListProps {
  data: EmailLogReportsResponse;
  loading: boolean;
  page: number;
  onPageChange: (page: number) => void;
  onCancelReport: (id: string) => void;
}

export default function Reports(props: ReportListProps) {
  const { t } = useTranslation("emailFlowLogs");
  const classes = useStyles();
  const { data, loading, page, onPageChange } = props;
  const { reports, total, pageSize } = data;

  const getPaginationLabel = context => {
    const { count, page } = context;
    const total = Math.ceil(count / pageSize);
    return t("reports.table.pagination.label", { page: page + 1, total });
  };

  return (
    <TableContainer component={Paper} style={{ marginTop: "20px" }}>
      <Table>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell className={classes.tableHeadContent} align="left">
              {t("reports.table.header.created")}
            </TableCell>
            <TableCell className={classes.tableHeadContent} align="left">
              {t("reports.table.header.status")}
            </TableCell>
            <TableCell className={classes.tableHeadContent} align="left">
              {t("reports.table.header.user")}
            </TableCell>
            <TableCell className={classes.tableHeadContent} align="left">
              {t("reports.table.header.filters")}
            </TableCell>
            <TableCell
              className={classes.tableHeadContent}
              align="left"
            ></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reports.map(item => (
            <ReportItem
              key={item.id}
              report={item}
              loading={loading}
              onCancelReport={props.onCancelReport}
            />
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell colSpan={3}>{t("reports.expiration")}</TableCell>
            <TablePagination
              page={page - 1}
              count={total}
              rowsPerPage={pageSize}
              rowsPerPageOptions={[]}
              labelDisplayedRows={getPaginationLabel}
              onPageChange={(_, page) => onPageChange(page + 1)}
              backIconButtonProps={{ size: "small" }}
              nextIconButtonProps={{
                size: "small",
                className: classes.nextButton,
              }}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
